module.exports = __webpack_public_path__ + "static/media/eiki47.d095452b.svg";